import PropTypes from 'prop-types'
import React, {useEffect, useState} from 'react'
import {Button} from '@chakra-ui/react'
import {
    ProductQuickviewModal,
    useProductQuickviewModal
} from '../../components/product-quickview-modal'

/**
 * Display ProductQuickviewModal
 *
 * @param {string} pid - productId
 *
 * @example
 *   <pwa-widget-hotspot pid="5968">
 *     $include(...)$
 *   </pwa-widget-hotspot>
 */
const WidgetHotspot = ({pid}) => {
    const quickViewModalProps = useProductQuickviewModal()
    const [hotspotButton, setHotspotButton] = useState(null)

    useEffect(() => {
        if (!hotspotButton?.parentElement?.parentElement) {
            return
        }
        if (quickViewModalProps.isOpen) {
            hotspotButton.parentElement.parentElement.classList?.add('active')
        } else {
            hotspotButton.parentElement.parentElement.classList?.remove('active')
        }
    }, [quickViewModalProps.isOpen, hotspotButton])

    return (
        <Button
            onClick={() => {
                quickViewModalProps.onOpen(pid)
            }}
            bg="transparent"
            height={10}
            width={10}
            zIndex="1"
            border="0"
            data-testid="hotspot-button"
            ref={setHotspotButton}
        >
            <ProductQuickviewModal
                {...quickViewModalProps}
                showAddToCartModal={false}
                scrollToTop={false}
                isLoading={false}
            />
        </Button>
    )
}

WidgetHotspot.propTypes = {
    pid: PropTypes.string
}

export default WidgetHotspot
